import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { AgendaItem } from "../../../data/repositories/agenda/entities/agenda.model";
import { AgendaRepository } from "../../repositories/agenda.repositories";

export class RetrieveWorkspaceUseCase implements UseCase<string, AgendaItem[]> {
  constructor(private agendaRepository: AgendaRepository) {}
  execute(rinaId: string): Observable<AgendaItem[]> {
    return this.agendaRepository.retrieveWorkspace(rinaId);
  }
}

const retrieveAgendaUseCaseFactory = (repo: AgendaRepository) =>
  new RetrieveWorkspaceUseCase(repo);

export const retrieveAgendaUseCaseProvider: Provider = {
  provide: RetrieveWorkspaceUseCase,
  useFactory: retrieveAgendaUseCaseFactory,
  deps: [AgendaRepository],
};
